module.exports = __webpack_public_path__ + "img/fav-folder-front-clay.cfa78c2e.png";